import { useWindow } from './useWindow';
import { useState, useEffect } from 'react';
export const useScrollValue = () => {
    const [scrollValue, setScrollValue] = useState(0);
    const myWindow = useWindow();
    const setScrollPercentage = (e) => {
        const target = e.target;
        const winScroll = target.body.scrollTop || target.documentElement.scrollTop;
        const height = target.documentElement.scrollHeight - target.documentElement.clientHeight;
        setScrollValue((winScroll / height) * 100);
    };
    useEffect(() => {
        if (!!myWindow) {
            myWindow.addEventListener('scroll', setScrollPercentage);
        }
        return () => {
            if (!!myWindow) {
                myWindow.removeEventListener('scroll', setScrollPercentage);
            }
        };
    }, [myWindow]);
    return {
        scrollValue
    };
};
